import { memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Img from '@UI/Img';
import ExpressDesignForm from '../ExpressDesignForm';
import picture from './picture.jpg';
import styles from './Application.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { TariffData } from '@Pages/PageExpressDesign/type';

interface ApplicationProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  tariffs: TariffData[];
  selectedTariff?: TariffData;
  selectedType: string;
  onSelectTariff?: (tariffId?: string) => void;
  onChangeType?: (type: string) => void;
  ofertaLink: string;
}

const Application: FC<ApplicationProps> = (props) => {
  const {
    className,
    tariffs,
    selectedTariff,
    selectedType,
    onSelectTariff,
    onChangeType,
    ofertaLink,
    ...restProps
  } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.content}>
        <div className={styles.title}>{t('application-express-design')}</div>
        <div className={styles.subtitle}>{t('contact-you')}</div>
        <ExpressDesignForm
          tariffs={tariffs}
          selectedTariff={selectedTariff}
          selectedType={selectedType}
          onSelectTariff={onSelectTariff}
          onChangeType={onChangeType}
          ofertaLink={ofertaLink}
        />
      </div>
      <div className={styles.imageWrapper}>
        <Img className={styles.image} cnImage={styles.cnImage} src={picture} />
      </div>
    </div>
  );
};

export default memo(Application);
